export const Spinner = () => {
  return (
    <>
      <style jsx>{`
        .spinner {
          margin-left: auto;
          margin-right: auto;
          width: 50px;
          height: 40px;
          text-align: center;
          font-size: 10px;
        }

        .spinner > div {
          background-color: #2d3748; // bg-gray-800
          height: 100%;
          width: 6px;
          display: inline-block;
          margin: 0 1px;

          -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
          animation: sk-stretchdelay 1.2s infinite ease-in-out;
        }

        .spinner .rect2 {
          -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s;
        }

        .spinner .rect3 {
          -webkit-animation-delay: -1s;
          animation-delay: -1s;
        }

        .spinner .rect4 {
          -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s;
        }

        .spinner .rect5 {
          -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s;
        }

        @-webkit-keyframes sk-stretchdelay {
          0%,
          40%,
          100% {
            -webkit-transform: scaleY(0.4);
          }
          20% {
            -webkit-transform: scaleY(1);
          }
        }

        @keyframes sk-stretchdelay {
          0%,
          40%,
          100% {
            transform: scaleY(0.4);
            -webkit-transform: scaleY(0.4);
          }
          20% {
            transform: scaleY(1);
            -webkit-transform: scaleY(1);
          }
        }
      `}</style>
      <div className="spinner">
        <div className="rect1" />
        <div className="rect2" />
        <div className="rect3" />
        <div className="rect4" />
        <div className="rect5" />
      </div>
    </>
  );
};
